export const exportqueueConstants = {
  DO_EXPORT: '[Dashboard] Export',
  DO_EXPORT_SUCCESS: '[Dashboard] Export success',
  DO_EXPORT_FAILURE: '[Dashboard] Export failure',
  CHECK_EXPORT: '[Export] Loading',
  CHECK_EXPORT_SUCCESS: '[Export] Loading success',
  CHECK_EXPORT_FAILURE: '[Export] Loading failure'
}
